export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS'
export const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES'

export function fetchCustomers(customers) {
  return { type: FETCH_CUSTOMERS, customers }
}

export function fetchEmployees(employees) {
  return { type: FETCH_EMPLOYEES, employees }
}